import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { getDoc, doc, collection, DocumentSnapshot } from "firebase/firestore"
import { db } from "../firebase"
import { FormProps, StepForm } from "./lib/StepForm"

const CustomerRegistration = () => {
  const urlParams = useParams<{ customerId: string }>()
  const [values, setValues] = useState<Record<string, string|number>>({})
  const [forms, setForms] = useState<Array<FormProps>>([])
  const navigate = useNavigate()

  useEffect(() => {
    getDoc(doc(collection(db, 'forms'), 'customer')).then((_: DocumentSnapshot) => {
      _.exists() && setForms(_.data().conf)
    })
    const storageValues = sessionStorage.getItem('customer')
    if (storageValues) {
      setValues(JSON.parse(storageValues))
      return
    } else {
      getDoc(doc(collection(db, 'customers'), urlParams.customerId)).then((_: DocumentSnapshot) => {
        const data = _.data()
        if (data && data.status === "init") {
          setValues(data)
        }
        else {
          window.confirm('既に顧客情報は登録済みです')
          navigate('/')
        }
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onSave = (values: Record<string, string | number>) => {
    setValues(values)
    sessionStorage.setItem('customer', JSON.stringify(values))
    navigate(`/customers/${urlParams.customerId}/confirm`)
  }

  return (
    <StepForm values={values} forms={forms} onSave={onSave} />
  )
}

export default CustomerRegistration
